
import React from "react";
import Navbar from "@/components/layout/Navbar";
import DictationInterface from "@/components/recording/DictationInterface";
import { Toaster } from "@/components/ui/toaster";

const Dictation = () => {
  return (
    // Make the root container a full-height flex column that prevents browser-level scroll
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      <div className="mobile-container pt-4 sm:pt-6 flex-shrink-0">
        <Navbar />
      </div>

      {/* The main area now expands to fill remaining space but hides its own overflow */}
      <main className="flex-1 mobile-container pb-4 sm:pb-6 overflow-hidden">
        {/* This container ensures the child can use h-full correctly */}
        <div className="max-w-6xl mx-auto h-full">
          <DictationInterface />
        </div>
      </main>

      <Toaster />
    </div>
  );
};

export default Dictation;
